import React from 'react'
import { AccordionSummary, AccordionDetails, Typography } from '@mui/material'
import CustomAccordion from '../Accordian/accordian'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { facility } from '../../models/DashboardInformation';
import { useGetOperatorGuidesQuery } from '../../api/endpoints/apiConfig';
interface FacilityInformationProps {
    data: facility | null;
}
const CallScript: React.FC<FacilityInformationProps> = ({ data }) => {
    const operatorId = sessionStorage.getItem('operatorId');
    const { data: FacilityOperatorAlerts } = useGetOperatorGuidesQuery(operatorId ? parseInt(operatorId) : 0);
    const removeHtmlTags = (text: string | null | undefined): string => {
        if (!text) {
            return ''; // Return an empty string for null or undefined input
        }

        // Decode any remaining HTML entities like &nbsp; and normalize spaces
        const textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        const decodedText = textArea.value.replace(/\s+/g, ' ').trim();

        return decodedText;
    };
    if (!data) {
        return (
            <CustomAccordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography variant="h3" color="text.secondary">Call Script
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    No Call Script available.
                </AccordionDetails>
            </CustomAccordion>
        );
    }
    const callsxript = data?.guides || [];
    const operatorsData = sessionStorage.getItem('operators');
    const operators = operatorsData ? JSON.parse(operatorsData) : [];
   
    const OperatorAlert = FacilityOperatorAlerts?.guides || [];
     // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const script = operators.operators[0]?.call_script;
    const sanitizedScript = removeHtmlTags(
        callsxript[0]?.facility_page_script || OperatorAlert[0]?.facility_page_script || ''
    );
    return (
        <>
            <CustomAccordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography variant="h3" color="text.secondary">Call Script
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                <Typography
                    color="text.primary"
                    textAlign={'left'}
                    dangerouslySetInnerHTML={{ __html: sanitizedScript }}
                />
                </AccordionDetails>
            </CustomAccordion>
        </>
    )
}
export default CallScript